<div
  *ngIf="!fileName"
  aria-label="Upload container"
  class="flex flex-col justify-center items-center p-4 dashed-border"
  [ngClass]="{
    'upload-container-active': isDragOver,
  }"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <div *ngIf="!isUploading" class="mt-2">
    <mat-icon
      aria-label="Cloud upload icon"
      class="material-icons-outlined text-icons-10 h-12 w-10 text-4xl"
      >cloud_upload</mat-icon
    >
  </div>

  <div
    *ngIf="!isUploading"
    aria-label="Upload logo description"
    class="text-2xl my-2"
  >
    {{ label | translate }}
  </div>
  <div *ngIf="!isUploading" aria-label="Or label" class="uppercase my-2">
    {{ 'global.or' | translate }}
  </div>
  <input
    *ngIf="!isUploading"
    #fileInput
    type="file"
    class="hidden"
    (change)="onFileSelected($event)"
  />
  <app-button
    aria-label="Button upload"
    [style]="ButtonStyle.OUTLINE"
    [icon]="isUploading ? '' : 'file_upload'"
    [loading]="isUploading"
    [disabled]="isUploading"
    (click)="triggerFileInput()"
  >
    {{ (isUploading ? 'upload.uploading' : 'upload.label') | translate }}
  </app-button>
</div>

<div
  *ngIf="imagePreview"
  class="mt-4 bg-[var(--primary-0)] flex items-center justify-between"
>
  <img
    [src]="imagePreview"
    aria-label="Upload Image preview"
    alt="Upload Image preview"
    class="w-[200px] h-12"
  />
  <mat-icon
    class="text-icons-20 cursor-pointer"
    aria-label="Delete uploaded file icon"
    (click)="deleteFile()"
    >delete</mat-icon
  >
</div>

<div
  *ngIf="showCsvPreview && !isUploading && selectedFile"
  class="upload-container-active rounded-md p-4"
>
  <div class="flex">
    <mat-icon
      class="material-icons-outlined icon-action h-12 w-12 text-5xl"
      aria-label="File icon"
      >insert_drive_file</mat-icon
    >
    <div class="flex justify-between w-full mx-2 pl-3">
      <div class="flex-col">
        <div class="font-medium">
          {{ selectedFile.name }}
        </div>
        <div>
          {{ selectedFileSize }}
        </div>
      </div>
      <div class="flex-col">
        <mat-icon
          class="ml-auto cursor-pointer"
          aria-label="Close and delete uploaded file icon"
          (click)="resetFileChanges()"
          >close</mat-icon
        >
      </div>
    </div>
  </div>
</div>
